import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

interface EmptyStateProps {
  /** Icon — emoji string, SVG, or a component like <FontAwesomeIcon /> */
  icon?: ReactNode;
  title?: string;
  message?: ReactNode;
  /** Action buttons or extra content rendered below the message */
  children?: ReactNode;
  className?: string;
}

export default function EmptyState({
  icon,
  title,
  message,
  children,
  className = '',
}: EmptyStateProps) {
  return (
    <div className={`${styles.emptyState} ${className}`.trim()}>
      {icon && <div className={styles.icon}>{icon}</div>}
      {title && <h3 className={styles.title}>{title}</h3>}
      {message && <p className={styles.message}>{message}</p>}
      {children && <div className={styles.actions}>{children}</div>}
    </div>
  );
}
